/** @jsxImportSource @emotion/react */
import React from 'react'

interface HockeyUSALogoProps {
  width?: number
  height?: number
  className?: string
}

const HockeyUSALogo: React.FC<HockeyUSALogoProps> = ({
  width = 180,
  height,
  className,
}) => {
  // Calculate height maintaining aspect ratio if not provided
  const calculatedHeight = height || (width * 124.4) / 250.1

  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width={width}
      height={calculatedHeight}
      viewBox='0 0 250.1 124.4'
      enableBackground='new 0 0 250.1 124.4'
      xmlSpace='preserve'
      className={className}
    >
      <g>
        <path
          fill='#FFFFFF'
          d='M227.4,44.71l0.4-0.15l12.73-4.78l-12.77-4.66c-6.8-2.48-14.29-4.85-22.25-7.07l-1.2-14.51l-1.12-13.49
        L195.23,11l-8.91,12.28C141.61,13.44,95,11.76,66.77,19.09c-3.85,1-4.66,4.83-5.6,9.28c-0.12,0.56-0.28,1.32-0.44,2
        C12.82,40.63,1.23,57.29,0.14,69.55C-1,82.32,9.09,94.93,26.7,103.19l-7.04,21.09h39.72l1-2.9c1.87,1.56,4.69,2.9,9.03,2.9h8.39
        c3.7,0,8.25-0.99,12.06-4.56c1.66,2.14,4.79,4.56,10.65,4.56h31.35l1.78-5.65l2.94,5.73l61.7-0.07l3.72-11.12l5.61-7.43
        c26.14-6.53,41.18-17.59,42.36-31.28C250.65,66.62,246.9,55.57,227.4,44.71'
        />
        <path
          fill='#BF311A'
          d='M200.87,31.95l-1.51-18.24l-12.15,16.75l-25.04-3.93l18.51,13.66l-13.24,20.59l24.35-10.58l18.17,18.83
        l-6.54-20.9l22.67-8.52L200.87,31.95z M68.11,23.71c-1.67,0.43-2.21,10.29-3.83,10.77c-90.57,18.65-61.8,61.6-14.85,70.43
        c10.13,3.99-85.31-37.66,13.63-56.48c1.42-0.48,2.02-10.63,3.5-11.08c32.39-9.78,98.65-9.81,159.53,2.25
        C171.58,19.72,103.12,14.62,68.11,23.71 M130.65,81.11c0,0-5.06,2.54-11.04,0.42c-15.76-5.98-25.32-0.38-26.5,0.11
        c-2.85,1.04-3.85,5.16-3.85,5.16s-7.34,2.53-15.08-2.02c0,0-1.93,5.14-3.01,7.93c0,0,6.37,4.24,15.31,3.22c0,0,1.85-0.33,2.08-2.59
        c0,0,13.56-9.98,30.57-2.78c0,0,4.1,1.48,5.76-0.74C124.9,89.84,129,84.22,130.65,81.11 M117.35,46.12l0.34,3.96
        c0,0.01,0,0.02,0,0.03l0.03,0.3l0.02,0c0.11,0.62,0.52,1.35,1.75,1.73l14.34,3.34c0,0,9.7,3.14,6.87,8.91l-5.56,9.21
        c0,0-1.91,2.91-3.33,3.85c0,0-2.64,3.65-16.87-2.02c0,0-12.38-3.64-21.72,2.83c0,0-0.61,1.82-1.32,3.74c0,0-6.47,3.95-18.16-1.66
        l3.08-8.19c0,0,9.02,5,17.26,0.42l1.13-3.29c0,0,0.74-4.99,12.78-3.77c0,0,8.15,0.72,20.1,5.26c2.13,0.43,3.53-0.41,4.94-2.83
        c0,0,2.03-2.53-2.32-4.05c0,0-4.75-1-10.92-2.53c0,0-7.06-1.61-6.16-4.36C113.6,57,115.69,51.08,117.35,46.12z'
        />
        <path
          fill='#003976'
          d='M111.21,61.71c0,0-0.61,1.92-2.9,3.85l-0.33-0.04c-12.04-1.22-12.78,3.77-12.78,3.77l-0.05,0.14
        c-1.24,0.01-14.81-0.15-12.12-11.43l6.67-18.51h12.54c0,0-5.28,14.9-5.95,16.68c-0.89,2.88,0.57,2.93,1.05,3.24
        c2.3,0.26,2.92-1.83,2.92-1.83l6.54-18.09H119L111.21,61.71z M151.71,50.87h4.31l-4.25,2.61l0.22,4.18l-3.17-2.46l-4.58,2.46
        l2.42-4.18l-2.57-2.61h4.33l2.83-4.16L151.71,50.87z M146.72,39.48l-11.81,16.43c2.45,1.03,8.01,3.94,5.78,8.49l-1.49,2.47
        l3.1-4.65h10.19l0.85,7.34h10.24l-4-30.1L146.72,39.48z M118.36,43.04c-0.3,0.93-0.65,1.98-1.01,3.08l0.34,3.96
        c-0.01-0.38,0.07-0.66,0.07-0.66c0.71-0.92,0.51-1.93,3.6-1.93h18.51l6.02-8.14L126,39.33C120.04,39.33,118.78,42.32,118.36,43.04z
         M156.43,88.65h-12.26l-11.05,14.98l4.99-14.98h-10.9l-10.06,30.33h11.09l4.34-13.8l7.12,13.88h11.07l-7.13-14.56L156.43,88.65z
         M148.68,119.06h31.99l2.71-8.06H162.3l1.14-3.86h13.67l2.89-7h-14.19l0.94-3.4h9.68l2.9-8.1h-20.47L148.68,119.06z M54.93,88.65
        l-3.6,10.17h-6.91l3.43-10.17H36.84l-10.12,30.33H37.4l4.06-11.22h6.97l-3.71,11.22h11.18l10.45-30.33H54.93z M69.49,118.98
        c-8.38,0-8.76-6.43-7.6-10.05c0.88-2.78,3.21-9.23,4.1-11.89c0.89-2.67,4-8.49,11.4-8.49c1.98,0,7.73,0.11,7.73,0.11
        c9.21,0,9.25,7.26,8.1,11.54c-0.7,2.62-2.13,7.91-2.94,9.83c-0.81,1.93-3.31,8.95-12.39,8.95H69.49z M82.66,100.15
        c0,0,0.81-3.5-2.77-3.5c-3.12,0-4.27,3.04-4.27,3.04l-2.3,6.64c0,0-0.99,4.11,2.79,4.11c3.74,0,4.6-3.47,4.6-3.47L82.66,100.15
         M107.2,110.44c-3.78,0-2.54-4.28-2.54-4.28l2.05-6.13c0,0,0.93-3.3,4.05-3.3l3.74,0.06l4.51,4.24l4.25-12.53
        c0,0-10.81,0.06-14.79,0.06c-7.4,0-10.76,5.82-11.65,8.49c-0.89,2.67-2.97,9.11-3.85,11.89c-1.15,3.62-0.78,10.05,7.6,10.05h24.37
        l0.9-8.65L107.2,110.44z M204.8,39.97c58.56,20.59,50.48,51.19-6.06,62.37C233.57,84.1,251.24,65.27,204.8,39.97 M191.21,88.65
        l3.14,11.1l8.24-11.13h11.51l-16.53,21.9l-2.84,8.47h-10.67l3.17-9.64l-6.49-20.69H191.21z'
        />
      </g>
    </svg>
  )
}

export default HockeyUSALogo
